export const capitalize = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);
export const toTitleCase = (str: string): string =>
  str
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ");

export const createWrapString =
  (lr: string, r?: string) =>
  (s?: string | null): string => {
    if (s === null || s === undefined) return "";

    return `${lr}${s}${r || lr}`;
  };
export const wrapQuotes = createWrapString(`"`);
export const noop = () => {};
